// extracted by mini-css-extract-plugin
export default {"elevation-modal":"undefined","container":"styles_container__XuQek","close":"styles_close__s3rQ-","window":"styles_window__E0LVm"};